import { atom } from "recoil"

export const shoppingBagState = atom({
  key: "shoppingBagState",
  default: [],
})

export const artworksState = atom({
  key: "artworksState",
  default: [],
})
